import { Link, useNavigate } from "react-router-dom";
import { MagnifyingGlass, House } from "@phosphor-icons/react";

export default function NotFound() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen grid place-items-center bg-orange-50 px-6" data-testid="not-found">
      <div className="max-w-lg w-full text-center">
        <div className="mx-auto h-16 w-16 rounded-full bg-orange-100 grid place-items-center mb-6">
          <MagnifyingGlass size={36} weight="duotone" className="text-orange-600" />
        </div>
        <div className="label-cap text-orange-700 mb-2">Error 404</div>
        <h1 className="font-display text-6xl font-black text-orange-950 mb-3">Page not found</h1>
        <p className="text-orange-900/80 leading-relaxed">
          The link you followed doesn't exist here, or you don't have access to it.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Link
            to="/"
            data-testid="notfound-home-btn"
            className="inline-flex items-center gap-2 px-5 h-11 rounded-sm bg-orange-600 hover:bg-orange-700 text-white font-semibold"
          >
            <House size={16} weight="bold" /> Take me home
          </Link>
          <button
            onClick={() => nav(-1)}
            className="inline-flex items-center gap-2 px-5 h-11 rounded-sm bg-white border border-orange-300 text-orange-800 hover:bg-orange-100 font-semibold"
          >
            Go back
          </button>
        </div>
      </div>
    </div>
  );
}
